module.exports = __webpack_public_path__ + "img/down-arrow-white.157f6258.svg";